import React from "react";
import iage1 from "../img/The begin of a grimoire&&---Blending textures over AI generated images on Adobe Photoshop___2025-06[[6]].jpg"
export default function Machine_1_2_8() {
  return (
    <div className="panel-block">
      

      <div className="panel-container-left">
        <img
          loading="lazy"
          src={iage1}
          alt="1.2.8 · OBSERVATIONAL NOTE"
        />
      </div>

      <div className="panel-container-right">
        <h2>1.2.8 · OBSERVATIONAL NOTE</h2>
        <p>Everything above may be inaccurate.</p>
    <p>Everything above may change.</p>
    <p>The Black Box does not care whether it is understood.</p>
    <p>It only responds to what persists.</p>
      </div>
    </div>
  );
}
